import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OrganizationState {
  organization: {
    name: string;
    details: string;
    teams: string[];
  } | null;
  setOrganization: (org: OrganizationState['organization']) => void;
}

const useOrganizationStore = create<OrganizationState>()(
  persist(
    (set) => ({
      organization: null,
      setOrganization: (org) => set({ organization: org }),
    }),
    {
      name: 'organization-storage',
    }
  )
);

export { useOrganizationStore };
